import axiosInstance from '@helpers/Axios';
import { logError, errorLogger } from '@utils/axios/ErrorLogging';

/** Body for `profiles/track-usage-time`; extra fields are tracker-specific (see UsageTracker). */
export interface UsageTrackerPayload {
  companyId?: string;
  [key: string]: unknown;
}

export const updateUsageTracker = async (payload: UsageTrackerPayload, callBack: (response: Record<string, unknown>) => void, onFailed: () => void, isPublicUser?: boolean) => {
  try {
    const response = await axiosInstance().post(`guest_v3/${isPublicUser ? `public/${payload.companyId}/` : ''}profiles/track-usage-time`, payload);

    // log the payload when empty response AND response code other than 200
    if (!response?.data || (typeof response.data === 'object' && Object.keys(response.data ?? {}).length === 0) || response.status !== 200) {
      errorLogger({ message: 'Error in usage tracker response', payload }, true, 'Caught from UsageTrackerService.ts from the method updateUsageTracker');
      onFailed?.();
    } else {
      callBack(response.data);
    }
  } catch (e) {
    logError(e, 'UsageTrackerService.ts', 'updateUsageTracker');
    onFailed?.();
  }
};
